import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSecureDataLocations } from 'services/secureDataSharing';

export const ThunkGetSecureDataLocations = createAsyncThunk(
  'secureDataSharing/getSecureDataLocations',
  () => getSecureDataLocations().then(r => r.data),
);
